import React from 'react';
import IconWrapper from '../IconWrapper';
const ChevronUpIcon = (props) => (React.createElement(IconWrapper, Object.assign({}, props),
    React.createElement("path", { d: "M12 9.757l4.95 4.95.707-.707-4.95-4.95L12 8.343 6.343 14l.707.707L12 9.757z" })));
export default ChevronUpIcon;
//# sourceMappingURL=ChevronUpIcon.js.map